import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/CS325WBBB.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Canadian Solar HIDM, 325W, PERC, All Black, 60C, 35mm_CS1H-325MS" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/CS325W.js